import React from 'react'
import './Loader.css'

export const Loader = () => {
  return (
    
    <div className='loader-container'><span class="loader"></span></div>
  )
}
